export const ru = {
  general: {
    days: 'дн.',
    subscribe: 'Подписаться',
    unlimitedSubscription: 'Безлимитная подписка',
    prolongateSubscription: 'Нажмите, чтобы продлить подписку',
  },
  hints: {
    chartLoadError: 'Не удалось загрузить данные графика.',
  },
  buttons: {
    goToMain: 'На главную',
  },
  generalInfo: {
    title: 'Цель на день',
    goals: {
      loss: 'Похудение',
      gain: 'Набор массы',
      maintain: 'Поддержание веса',
    },
    nutrients: {
      calories: 'Калории',
      proteins: 'Белки',
      fats: 'Жиры',
      carbs: 'Углеводы',
    },
    units: {
      kcal: 'ккал',
      g: 'г',
    },
    status: {
      remaining: 'осталось {{value}}',
      exceeded: 'превышение {{value}}',
    },
    toStats: 'Смотреть статистику',
    error: {
      target: 'Не удалось загрузить вашу цель. Попробуйте позже.',
    },
    noTarget:
      'Цель на день ещё не установлена. Вы можете установить её через бота',
  },
  graphStats: {
    title: 'Статистика питания',
    modes: {
      today: 'Сегодня',
      period: 'Период',
    },
    metrics: {
      calories: 'Калории',
      proteins: 'Белки',
      fats: 'Жиры',
      carbs: 'Углеводы',
    },
    compareWithYesterday: 'Сравнить со вчера',
    periods: {
      week: 'Неделя',
      twoWeeks: '2 недели',
      month: 'Месяц',
    },
    series: {
      today: 'Сегодня',
      yesterday: 'Вчера',
      target: 'Цель',
    },
    mealTypes: {
      breakfast: 'Завтрак',
      morning_snack: 'Утр. перекус',
      lunch: 'Обед',
      afternoon_snack: 'Полдник',
      dinner: 'Ужин',
      evening_snack: 'Веч. перекус',
      unknown: 'Другое',
    },
    empty: {
      today: 'Сегодня ещё нет приёмов пищи.',
      period: 'Нет данных за этот период.',
    },
    units: {
      kcal: 'ккал',
      g: 'г',
    },
    error: {
      meals: 'Не удалось загрузить данные о приёмах пищи. Попробуйте позже.',
      target: 'Не удалось загрузить вашу цель. Попробуйте позже.',
    },
  },
  meal: {
    mealTypes: {
      breakfast: 'Завтрак',
      morning_snack: 'Утр. перекус',
      lunch: 'Обед',
      afternoon_snack: 'Полдник',
      dinner: 'Ужин',
      evening_snack: 'Веч. перекус',
      unknown: 'Другое',
    },
    nutrients: {
      proteins: 'Белки',
      fats: 'Жиры',
      carbs: 'Углеводы',
    },
    macroShort: {
      proteins: 'Б',
      fats: 'Ж',
      carbs: 'У',
    },
    units: {
      kcal: 'ккал',
      g: 'г',
    },
    edited: 'изменено',
    items: {
      title: 'Состав',
      empty: 'В этом приёме пищи нет позиций.',
    },
    editTitle: 'Редактирование',
    form: {
      title: 'Название',
      description: 'Описание',
      type: 'Тип приёма пищи',
      itemName: 'Название позиции',
      totals: 'Итого',
    },
    buttons: {
      edit: 'Редактировать',
      delete: 'Удалить приём пищи',
      save: 'Сохранить изменения',
      cancel: 'Отмена',
      addItem: 'Добавить позицию',
      confirmDelete: 'Удалить',
    },
    deleteConfirm: {
      question: 'Удалить этот приём пищи?',
      hint: 'Это действие нельзя отменить.',
    },
    success: {
      update: 'Изменения сохранены.',
      delete: 'Приём пищи удалён.',
    },
    error: {
      load: 'Не удалось загрузить приём пищи. Попробуйте позже.',
      update: 'Не удалось сохранить изменения. Попробуйте позже.',
      delete: 'Не удалось удалить приём пищи. Попробуйте позже.',
    },
  },
  mealsList: {
    title: 'Приёмы пищи',
    today: 'Сегодня',
    pickDate: 'Выбрать дату',
    weekdays: {
      0: 'Вс',
      1: 'Пн',
      2: 'Вт',
      3: 'Ср',
      4: 'Чт',
      5: 'Пт',
      6: 'Сб',
    },
    mealTypes: {
      breakfast: 'Завтрак',
      morning_snack: 'Утр. перекус',
      lunch: 'Обед',
      afternoon_snack: 'Полдник',
      dinner: 'Ужин',
      evening_snack: 'Веч. перекус',
      unknown: 'Приём пищи',
    },
    macroShort: {
      proteins: 'Б',
      fats: 'Ж',
      carbs: 'У',
    },
    units: {
      kcal: 'ккал',
    },
    total: 'Итого',
    empty: 'В этот день нет приёмов пищи.',
    error: {
      meals: 'Не удалось загрузить данные о приёмах пищи. Попробуйте позже.',
    },
  },
}
